<ui-confirmation-dialog
    header="employees.tasks-template.deleteTemplate"
    primaryButtonLabel="delete"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
    #confirmDeleteModal
>
    <p>{{ 'employees.tasks-template.deleteConfirmation' | translate: { templateName: currentTaskTemplateName } }}</p>
</ui-confirmation-dialog>

<!-- Body -->
<div class="page-container">
    <app-header
        title="{{ 'employees.tasks-template.people' | appTranslate }}"
        [menuService]="employeeModuleMenuService"
    >
        <div class="buttons" *ngIf="hasManageTaskTemplatesPermission">
            <ui-button type="primary" (click)="onNewTask($event)"
                ><mat-icon svgIcon="plus"></mat-icon
                >{{ 'employees.tasks-template.createTaskTemplate' | appTranslate }}</ui-button
            >
        </div>
    </app-header>

    <app-table [table]="table" (menuItemSelected)="onTableMenuEvent($event)">
        <div class="empty">
            <app-empty-state
                label="{{
                    table.hasFiltersApplied()
                        ? 'employees.tasks-template.noTaskTemplatesFoundForTheAppliedFilters'
                        : 'employees.tasks-template.noTemplatesCurrentlyExistPleaseCreateAndAssignATemplateToGetStar'
                }}"
                src="/assets/illustrations/cup.png"
            >
            </app-empty-state>
            <div
                class="buttons create-task-template-button"
                *ngIf="hasManageTaskTemplatesPermission && !table.hasFiltersApplied()"
            >
                <ui-button type="primary" (click)="$event.preventDefault(); onCreateTaskTemplate()">{{
                    'employees.tasks-template.createTaskTemplate' | translate
                }}</ui-button>
            </div>
        </div>
    </app-table>
</div>
